import React from "react";
import {Radio, FormControlLabel, FormControl, RadioGroup} from "@material-ui/core";
import Property from "../model/property";
import {makeStyles} from "@material-ui/core/styles";
import {get} from "lodash"
import VisaImg from "../assets/basket/Visa.png"
import AmexImg from "../assets/basket/American Express.png"
import JcbImg from "../assets/basket/JCB.png"
import MasterImg from "../assets/basket/Master Card.png"


const PaymentMethod = (props) => {
  const preset = Property.getPreset()
  const paymentMethod = Property.getPaymentMethod()
  const radioButtonStyles = makeStyles({
    label: {
      color: "gray",
      fontSize: "11pt"
    }
  });
  const classes = radioButtonStyles()
  
  const handleChange = (event, item) => {
    props.handler(item)
  };
  return (
      <>
        <div style={{ backgroundColor: 'rgb(234, 234, 234)', padding: '12px 16px' }}>
          <div style={{ color: '#7A7A7A', alignSelf: 'center', fontSize: '15px' }}>
            Payment Method
          </div>
        </div>
        <div>
          <FormControl style={{ width: '100%', padding: '6px 32px' }}>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
            >
              <FormControlLabel value="adyen"
                                onChange={(event) => handleChange(event, 'adyen')}
                                classes={{
                                  label: classes.label
                                }}
                                control={<Radio style={{
                                  color: `${preset.app_home_color_secondary}`
                                  , paddingTop: '3px'
                                }}/>}
                                style={{ marginBottom: '5px', marginTop: '10px', alignItems: `flex-start` }}
              label={
              <>
                {"Pay with Credit Card"}
                <img src={AmexImg} alt="american express" height="auto" style={{ display: "inline-block", marginLeft: "30px" }}/>
                <img src={JcbImg}  alt="jcb" height="auto" style={{ display: "inline-block", marginLeft: "5px" }}/>
                <img src={MasterImg} alt="master card" height="auto" style={{ display: "inline-block", marginLeft: "5px" }}/>
                <img src={VisaImg}  alt="visa card" height="auto" style={{ display: "inline-block", marginLeft: "5px" }}/>
        </>
    }
              />
              <hr/>
              {get(paymentMethod,'enable_bill_to_room',false) &&
              (<>
                <FormControlLabel value="bill_to_room"
                                  onChange={(event) => handleChange(event, 'bill_to_room')}
                                  classes={{
                                    label: classes.label
                                  }}
                                  control={<Radio style={{
                                    color: `${preset.app_home_color_secondary}`
                                    , paddingTop: '3px'
                                  }}/>}
                                  style={{ marginBottom: '5px', marginTop: '10px', alignItems: `flex-start` }}
                                  label={paymentMethod.bill_to_room}/>
                <hr/>
              </>)
              }
              {get(paymentMethod,'enable_pay_by_cash',false) &&
              (<>
                <FormControlLabel value="pay_by_cash"
                                  onChange={(event) => handleChange(event, 'pay_by_cash')}
                                  classes={{
                                    label: classes.label
                                  }}
                                  control={<Radio style={{
                                    color: `${preset.app_home_color_secondary}`
                                    , paddingTop: '3px'
                                  }}/>}
                                  style={{ marginBottom: '5px', marginTop: '10px', alignItems: `flex-start` }}
                                  label={paymentMethod.pay_by_cash}/>
                <hr/>
              </>)
              }
            </RadioGroup>
            {props.notification &&
            (
                <div style={{ color: 'red', fontSize: '10pt', margin: '10px auto' }}>PLEASE SELECT PAYMENT METHOD</div>
            )
            }
          </FormControl>
        </div>
      </>
  )
}

export default PaymentMethod
